import(/* webpackMode: "eager" */ "/app/src/app/[locale]/signup/error.tsx");
